import React, { useState, useRef, useEffect } from 'react';
import { FaUser } from "react-icons/fa";
import { FaCogs } from "react-icons/fa";
import { FaCircleInfo } from "react-icons/fa6";
import { IoMdSave } from "react-icons/io";
import axios from "axios";

// adjust API endpoints according to comment instructions and @authRoutes.ts mapping:
//  - GET user data:           /api/auth/user/:id         (@authRoutes.ts 97-112)
//  - UPDATE user data:        /api/auth/user/:id         (PUT, @authRoutes.ts 975-1048)
//  - UPDATE extra data:       /api/auth/user/settings/:id (PUT, @authRoutes.ts 289-418)


const api_base = process.env.REACT_APP_API_BASE;

function Profile() {
    // Example user id, should come from auth/session
    let userId = null;
    const token = localStorage.getItem('token');
    
    if (token) {
        try {
            const payload = token.split('.')[1];
            const payloadDecoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
            userId = payloadDecoded.userId || null;
        } catch (err) {
            console.error("Failed to decode token:", err);
        }
    }
    
    // Local state
    const [activetab, setactive] = useState('profile');
    const [LoginNotification, setLoginnotification] = useState(false);
    const [IpValidation, setIpValidation] = useState(false);
    const [ipAddresses, setIpAddresses] = useState('');
    const [WebPushDelivery, setWebPushDelivery] = useState(false);
    const [webUrls, setWebUrls] = useState('');
    const [image, setImage] = useState(
        "https://globeomni.com/Image/ProfilePic/Anonymous.png"
    );
    const [imageFile, setImageFile] = useState(null);

    // User data from API
    const [userData, setUserData] = useState({
        name: "",
        number: "",
        address: "",
        email: "",
        city: "",
        state: "",
        pinCode: "",
        registrationDate: "",
        expiry: "",
        api_key: "",
        isLoginNotificationSent: false
    });

    // Editable fields
    const [MobileNumber, setMobileNumber] = useState('');
    const [email, setemail] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [pinCode, setPinCode] = useState('');
    const [metaIds, setMetaIds] = useState({
        address: null,
        city: null,
        state: null,
        pinCode: null,
        apiKey: null
    });

    useEffect(() => {
        async function fetchAllData() {
            if (!userId) return;
            try {
                // 1. Fetch Base User Data (Name, Email, Number) ***changed api here!***
                const userRes = await axios.get(`${api_base}/auth/user/${userId}`);
                const currentUser = userRes.data.user;
                console.log("currentUser ", currentUser)
                if (currentUser) {
                    setUserData(prev => ({ ...prev, name: currentUser.name }));
                    setemail(currentUser.email || "");
                    setMobileNumber(currentUser.mobile || "");
                    if (currentUser.profile) {
                        let imgUrl = currentUser.profile;
                        if (typeof imgUrl === 'string' && imgUrl.startsWith('"') && imgUrl.endsWith('"')) {
                            imgUrl = imgUrl.slice(1, -1);
                        }
                        setImage(`${api_base}${imgUrl.replace(/"/g, '')}`);
                   
                    }
                }

                // 2. Fetch User Meta Data (Address, City, State, etc.)
                const metaRes = await axios.get(`${api_base}/auth/user-meta/${userId}`);
                const metaArray = metaRes.data.meta || [];
                const newMetaIds = { ...metaIds };
                metaArray.forEach(item => {
                    if (item.meta_key === 'address') { setAddress(item.meta_value); newMetaIds.address = item.id; }
                    if (item.meta_key === 'city') { setCity(item.meta_value); newMetaIds.city = item.id; }
                    if (item.meta_key === 'state') { setState(item.meta_value); newMetaIds.state = item.id; }
                    if (item.meta_key === 'pinCode') { setPinCode(item.meta_value); newMetaIds.pinCode = item.id; }
                    if (item.meta_key === 'apiKey') { setUserData(prev => ({ ...prev, apiKey: item.meta_value })); newMetaIds.apiKey = item.id; }
                });
                setMetaIds(newMetaIds);

            } catch (err) {
                console.error("Error fetching data", err);
            }
        }
        fetchAllData();
        // eslint-disable-next-line
    }, [userId]);
    const fileInputRef = useRef(null);

    // Fetch user data from backend (single user endpoint)
    useEffect(() => {
        async function fetchUserData() {
            if (!userId) return;
            try {
                // Fetch single user
                const res = await axios.get(`${api_base}/auth/user/${userId}`);
                const currentUser = res.data.user;
                if (currentUser) {
                    setUserData({
                        name: currentUser.name || "",
                        number: currentUser.number || "",
                        email: currentUser.email || "",
                        address: currentUser.address || "",
                        city: currentUser.city || "",
                        state: currentUser.state || "",
                        pinCode: currentUser.pinCode || "",
                        api_key: currentUser.api_key || "",
                        isLoginNotificationSent: !!currentUser.isLoginNotificationSent,
                        registrationDate: currentUser.createdAt || "",
                        expiry: currentUser.expiry || "",
                    });
                    setMobileNumber(currentUser.number || "");
                    setemail(currentUser.email || "");
                    setAddress(currentUser.address || "");
                    setCity(currentUser.city || "");
                    setState(currentUser.state || "");
                    setPinCode(currentUser.pinCode || "");
                    setLoginnotification(!!currentUser.isLoginNotificationSent);
                    // Profile image handling
                    if (
                        currentUser.profile && 
                        typeof currentUser.profile === "string" && 
                        currentUser.profile !== "" &&
                        currentUser.profile !== "\"\""
                    ) {
                        let imgUrl = currentUser.profile;
                        if (imgUrl.startsWith('"') && imgUrl.endsWith('"')) {
                            imgUrl = imgUrl.slice(1, -1);
                        }
                        setImage(`${api_base}${imgUrl}`);
                   
                    }

                }
            } catch (err) {
                // handle error/get default empty
            }
        }
        fetchUserData();
    }, [userId]);

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
            setImageFile(file);
        }
    };

    // Handle profile info update (PUT /api/auth/user/:id)
    const handleUpdate = async () => {
        try {
            // 1. Update Base User Info (Email, Number, Profile Image)
            const baseFormData = new FormData();
            baseFormData.append('email', email);
            baseFormData.append('number', MobileNumber);
            if (imageFile) baseFormData.append('profile', imageFile);

            await axios.put(`${api_base}/auth/user/${userId}`, baseFormData, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            // 2. Helper function to update or create meta
            const saveMeta = async (key, value, existingId) => {
                if (existingId) {
                    // UPDATE existing record
                    await axios.put(`${api_base}/auth/user-meta/${existingId}`, {
                        meta_value: value
                    });
                } else {
                    // CREATE new record
                    await axios.post(`${api_base}/auth/user-meta`, {
                        user_id: userId,
                        meta_key: key,
                        meta_value: value
                    });
                }
            };

            // 3. Save all meta fields
            await Promise.all([
                saveMeta('address', address, metaIds.address),
                saveMeta('city', city, metaIds.city),
                saveMeta('state', state, metaIds.state),
                saveMeta('pinCode', pinCode, metaIds.pinCode)
            ]);

            alert('Profile and Meta data updated successfully!');
            window.location.reload(); // Refresh to get new meta IDs
        } catch (err) {
            console.error(err);
            alert('Error updating profile');
        }
    };

    // Handle save for "Setting" tab (extra data, /authRoutes.ts 289-418)
    const handleSettingsSave = async () => {
        try {
            await axios.put(
                `${api_base}/auth/user/settings/${userId}`,
                {
                    ipValidation: IpValidation,
                    ipAddresses,
                    webPushDelivery: WebPushDelivery,
                    webUrls
                }
            );
            alert('Settings updated!');
        } catch (err) {
            alert('Error updating settings');
        }
    };

    return (
        <>
            <div className='mt-[120px] sm:mt-[50px] px-4 dark:bg-[#121519] min-h-screen pb-8'>
                <div className='w-[100%] flex flex-wrap gap-2 border-b-[1px] border-[#cfcdcd] pt-3 pb-3 '>
                    <button
                        onClick={() => setactive('profile')}
                        className={`flex items-center text-[12px] font-semibold gap-2 ${activetab === 'profile'
                            ? 'border-b-[2px] border-[#ed7b00] text-[#ed7b00]'
                            : 'border-b-[1px] border-transparent text-[#61748f]'
                            } px-2 py-2`}
                    >
                        <FaUser />My Profile
                    </button>
                    <button
                        onClick={() => setactive('Setting')}
                        className={`flex items-center text-[12px] font-semibold gap-2 ${activetab === 'Setting'
                            ? 'border-b-[2px] border-[#ed7b00] text-[#ed7b00]'
                            : 'border-b-[1px] border-transparent text-[#61748f]'
                            } px-2 py-2`}
                    >
                        <FaCogs />
                        Setting
                    </button>
                </div>
                {activetab === 'profile' ? (
                    <div className='w-[100%] flex items-center justify-center mt-4 px-2'>
                        <div className='w-[100%] sm:w-[90%] md:w-[70%] lg:w-[60%]'>
                            {/* Profile Section */}
                            <div className='w-[100%] flex flex-col sm:flex-row justify-center items-center sm:items-start gap-3'>
                                <div>
                                    <img
                                        src={image}
                                        alt=""
                                        className='w-[80px] h-[80px] rounded-full cursor-pointer border-[#cfcdcd] border-[1px]'
                                        onClick={handleImageClick}
                                        accept="image/*"
                                    />
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                        className="hidden"
                                        accept="image/*"
                                    />
                                </div>
                                <div className='flex flex-col h-[80px] justify-center text-center sm:text-left'>
                                    <h6 className='text-[#000] text-[13px] font-semibold'>{userData.name}</h6>
                                    <p className='text-[#3f7fca] text-[12px] flex items-center justify-center sm:justify-start gap-2'>
                                        <FaCircleInfo />
                                        Only PNG or JPG formats are allowed, with a maximum size of 150 KB and dimensions of 150x150 pixels
                                    </p>
                                </div>
                            </div>
                            {/* Form Section */}
                            <div className='w-[100%] flex flex-wrap gap-y-2 items-center justify-between mt-4'>
                                <div className='w-[100%] sm:w-[48%] flex flex-col'>
                                    <label className='text-[#000] text-[12px] font-semibold'>User Name</label>
                                    <input className='border-[#d4cfcf] text-[#454546] border rounded-md mt-1 outline-none text-[12px] p-2'
                                        value={userData.name}
                                        disabled
                                    />
                                </div>
                                <div className='w-[100%] sm:w-[48%] flex flex-col'>
                                    <label className='text-[#000] text-[12px] font-semibold'>Mobile Number</label>
                                    <input className='border-[#d4cfcf] text-[#454546] border rounded-md mt-1 outline-none text-[12px] p-2'
                                        maxLength={12}
                                        value={MobileNumber}
                                        onChange={e => setMobileNumber(e.target.value)}
                                    />
                                </div>
                                <div className='w-[100%] flex flex-col'>
                                    <label className='text-[#000] text-[12px] font-semibold'>Address</label>
                                    <textarea className='border-[#d4cfcf] text-[#454546] border rounded-md mt-1 outline-none w-[100%] text-[12px] p-2'
                                        value={address}
                                        onChange={e => setAddress(e.target.value)}
                                    />
                                </div>
                                <div className='w-[100%] sm:w-[48%] flex flex-col'>
                                    <label className='text-[#000] text-[12px] font-semibold'>Email Address</label>
                                    <input className='border-[#d4cfcf] text-[#454546] border rounded-md mt-1 outline-none text-[12px] p-2'
                                        value={email}
                                        onChange={e => setemail(e.target.value)}
                                    />
                                </div>
                                <div className='w-[100%] sm:w-[48%] flex flex-col'>
                                    <label className='text-[#000] text-[12px] font-semibold'>City</label>
                                    <input className='border-[#d4cfcf] text-[#454546] border rounded-md mt-1 outline-none text-[12px] p-2'
                                        value={city}
                                        onChange={e => setCity(e.target.value)}
                                    />
                                </div>
                                <div className='w-[100%] sm:w-[48%] flex flex-col'>
                                    <label className='text-[#000] text-[12px] font-semibold'>State</label>
                                    <input className='border-[#d4cfcf] text-[#454546] border rounded-md mt-1 outline-none text-[12px] p-2'
                                        value={state}
                                        onChange={e => setState(e.target.value)}
                                    />
                                </div>
                                <div className='w-[100%] sm:w-[48%] flex flex-col'>
                                    <label className='text-[#000] text-[12px] font-semibold'>PinCode</label>
                                    <input className='border-[#d4cfcf] text-[#454546] border rounded-md mt-1 outline-none text-[12px] p-2'
                                        value={pinCode}
                                        onChange={e => setPinCode(e.target.value)}
                                    />
                                </div>
                                <div className='w-[100%] sm:w-[48%] flex flex-col'>
                                    <label className='text-[#000] text-[12px] font-semibold'>Registration Date</label>
                                    <input className='border-[#d4cfcf] text-[#454546] border rounded-md mt-1 outline-none text-[12px] p-2'
                                        value={
                                            userData.registrationDate
                                                ? new Date(userData.registrationDate).toLocaleString('en-US', {
                                                    month: 'numeric',
                                                    day: 'numeric',
                                                    year: 'numeric',
                                                    hour: 'numeric',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                    hour12: true
                                                })
                                                : ""
                                        }
                                   
                                        disabled
                                    />
                                </div>
                                <div className='w-[100%] sm:w-[48%] flex flex-col'>
                                    <label className='text-[#000] text-[12px] font-semibold'>Account Expiry Date</label>
                                    <input className='border-[#d4cfcf] text-[#454546] border rounded-md mt-1 outline-none text-[12px] p-2'
                                        value={
                                            userData.expiry
                                                ? new Date(userData.expiry).toLocaleString('en-US', {
                                                    month: 'numeric',
                                                    day: 'numeric',
                                                    year: 'numeric',
                                                    hour: 'numeric',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                    hour12: true
                                                })
                                                : ""
                                        }
                                   
                                        disabled
                                    />
                                </div>
                                <div className='w-[100%] sm:w-[48%] flex flex-col'>
                                    <label className='text-[#000] text-[12px] font-semibold'>API Key</label>
                                    <input className='border-[#d4cfcf] text-[#454546] border rounded-md mt-1 outline-none text-[12px] p-2'
                                        value={userData.api_key}
                                        disabled
                                    />
                                </div>
                                <div className='w-[100%] sm:w-[48%] flex flex-col'>
                                    <div className='w-[100%] flex justify-start gap-3 items-center'>
                                        <button
                                            onClick={() => setLoginnotification(!LoginNotification)}
                                            className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${!LoginNotification ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}
                                            type="button"
                                        >
                                            <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${!LoginNotification ? "translate-x-[13px]" : ""}`}></div>
                                        </button>
                                        <span
                                            onClick={() => setLoginnotification(!LoginNotification)}
                                            className='text-[#858c97] text-[12px] font-semibold cursor-pointer'>
                                            Is Login Notification Sent
                                        </span>
                                    </div>
                                </div>
                            </div>
                            {/* Button */}
                            <div className='w-[100%] flex justify-center sm:justify-start items-center mt-4'>
                                <button
                                    onClick={handleUpdate}
                                    className='p-2 bg-[#ed7b00] rounded-md text-[12px] flex items-center gap-1 font-semibold text-[#fff]'
                                >
                                    <IoMdSave /> Save
                                </button>
                            </div>
                        </div>
                    </div>
                ) : null}
                {activetab === 'Setting' ? (
                    <div className='w-[100%] mt-4 px-2'>
                        <div>
                            <input type="checkbox" name="" id="IpValidation"
                                className='accent-[#00816a] mr-2'
                                checked={IpValidation}
                                onChange={e => setIpValidation(e.target.checked)}
                            />
                            <label htmlFor="IpValidation" className='text-[#454546] text-[12px]'>IP Validation</label>
                        </div>
                        {IpValidation && (
                            <div className='md:w-[70%] w-[100%] border-[1px] border-[#cfcdcd] p-2 flex gap-2 rounded-lg mt-1'>
                                <span className='text-[#454546] text-[14px] font-semibold'>IP Address |</span>
                                <input type="text"
                                    className='text-[#454546] text-[12px] placeholder:text-[#454546] outline-none font-semibold w-[50%]'
                                    placeholder='e.g 127.0.0.1, 192.168.1.1'
                                    value={ipAddresses}
                                    onChange={e => setIpAddresses(e.target.value)}
                                />
                            </div>
                        )}
                        <div>
                            <input type="checkbox" name="" id="WebPushDelivery"
                                className='accent-[#00816a] mr-2'
                                checked={WebPushDelivery}
                                onChange={e => setWebPushDelivery(e.target.checked)}
                            />
                            <label htmlFor="WebPushDelivery" className='text-[#454546] text-[12px]'>Web Push Delivery</label>
                        </div>
                        {WebPushDelivery && (
                            <div className='md:w-[70%] w-[100%] border-[1px] border-[#cfcdcd] p-2 flex gap-2 rounded-lg mt-1'>
                                <span className='text-[#454546] text-[14px] font-semibold'>Web Url |</span>
                                <input type="text"
                                    className='text-[#454546] text-[12px] placeholder:text-[#454546] outline-none font-semibold w-[50%]'
                                    placeholder='e.g http://example.com'
                                    value={webUrls}
                                    onChange={e => setWebUrls(e.target.value)}
                                />
                            </div>
                        )}
                        <button
                            className='p-2 bg-[#ed7b00] rounded-md text-[12px] flex items-center gap-1 font-semibold text-[#fff] mt-4'
                            onClick={handleSettingsSave}
                        >
                            <IoMdSave /> Save
                        </button>
                    </div>
                ) : null}
            </div>
        </>
    );
}

export default Profile;
